import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { api } from '../../api';
import { pode, useSessao } from '../../sessao';
import { NOME_STATUS_CONTRATO, NOME_TIPO_CONTRATO, dataBr } from './comum';

/** Contratos na ficha do cliente (só para quem vê contratos). */
export function ContratosDoCliente({ clienteId }: { clienteId: string }) {
  const { usuario } = useSessao();
  const ver = pode(usuario, 'contratos.ver');
  const [lista, setLista] = useState<{ id: string; numero: string; tipo: string; status: string; inicio: string; fim: string | null }[] | null>(null);
  useEffect(() => { if (ver) api<typeof lista>(`/contratos?cliente_id=${clienteId}`).then(setLista).catch(() => setLista([])); }, [clienteId, ver]);
  if (!ver || !lista) return null;
  return (
    <section className="secao">
      <div className="secao-topo"><h2>Contratos <span className="contador">{lista.length}</span></h2></div>
      {lista.length === 0 ? <p className="nota">Nenhum contrato. OS deste cliente saem como avulsas (sem SLA).</p> : (
        <div className="cartao tabela-cartao rolagem-x">
          <table className="tabela">
            <thead><tr><th>Número</th><th>Tipo</th><th>Vigência</th><th>Situação</th></tr></thead>
            <tbody>
              {lista.map((k) => (
                <tr key={k.id}>
                  <td><Link to={`/contratos/${k.id}`}>{k.numero}</Link></td>
                  <td>{k.tipo === 'a_classificar' ? <span className="situacao s-aviso">A classificar</span> : NOME_TIPO_CONTRATO[k.tipo]}</td>
                  <td>{dataBr(k.inicio)} → {k.fim ? dataBr(k.fim) : 'indeterminado'}</td>
                  <td>{NOME_STATUS_CONTRATO[k.status]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
